{
    "translation": {
        "errors": {
            "password_requirements": "Your password has to have at least 9 Characters and must contain a number, uppercased character, lowercased character and a special character.",
            "password_confirm": "Passwords do not match"
        },

        "generic": {
            "fetching": "Fetching data...",
            "submit": "Submit",
            "page_not_found": "Page not found",
            "support": "Support",
            "error_title": "Sorry, something went wrong.",
            "error_text": "The error '{{ errorMessage }}' occured. Please contact the support for help.",
            "unknown_error_text": "An unknown error occured. Please contact the support for help."
        },

        "email_activation": {
            "title": "E-Mail Activation",
            "success_title": "Welcome to Anio!",
            "success_text": "The E-Mail was successfully verified and the account is activated."
        },

        "password_reset": {
            "title": "Reset Password",
            "new_password": "New Password",
            "new_password_confirm": "Confirm new Password",
            "success_title": "The password was successfully reset!"
        },

        "friend_code": {
            "title": "Add Friend",
            "description": "You have been invited to add a friend in the Anio app.<br />Simply enter the following code in the Friends menu of the Anio app:",
            "copy_code": "Copy code",
            "code_copied": "Code copied to clipboard!"
        }
    }
}
